// Daos Ads /studiovideo — presets and constants.

export const FORMATS = [
  { id: "reels",  label: "Instagram Reels · 1080×1920", width: 1080, height: 1920 },
  { id: "feed",   label: "Instagram Feed · 1080×1080",  width: 1080, height: 1080 },
  { id: "tiktok", label: "TikTok · 1080×1920",           width: 1080, height: 1920 },
];

export const CTA_PRESETS = [
  { id: "url",      label: "daosads.com",          value: "daosads.com" },
  { id: "quote",    label: "Cotiza tu proyecto",   value: "Cotiza tu proyecto" },
  { id: "free",     label: "Asesoría gratis",      value: "Asesoría gratis" },
  { id: "contact",  label: "Contáctame",           value: "Contáctame" },
  { id: "call",     label: "Agenda una llamada",   value: "Agenda una llamada" },
  { id: "write",    label: "Escríbeme",            value: "Escríbeme" },
];

export const CTA_COLOR_FILLS = {
  gradient: null,
  orange: "#FF8A00",
  green:  "#25D366",
  amber:  "#FFB020",
  red:    "#F43F5E",
  white:  "#FFFFFF",
};

export const CTA_COLOR_OPTIONS = [
  { id: "gradient", label: "Degradado", swatch: "linear-gradient(135deg,#FF3B1F 0%,#FF8A00 50%,#FFD23F 100%)" },
  { id: "orange",   label: "Naranja",   swatch: CTA_COLOR_FILLS.orange },
  { id: "green",    label: "Verde",     swatch: CTA_COLOR_FILLS.green },
  { id: "amber",    label: "Ámbar",     swatch: CTA_COLOR_FILLS.amber },
  { id: "red",      label: "Rojo",      swatch: CTA_COLOR_FILLS.red },
  { id: "white",    label: "Blanco",    swatch: CTA_COLOR_FILLS.white },
];

export const SIGNAL_COLORS = { green: "#25D366", amber: "#FFB020", red: "#F43F5E" };

export const SIGNAL_COLOR_OPTIONS = [
  { id: "none",  label: "Sin señal",   swatch: null },
  { id: "green", label: "Verde",       swatch: SIGNAL_COLORS.green },
  { id: "amber", label: "Ámbar",       swatch: SIGNAL_COLORS.amber },
  { id: "red",   label: "Rojo",        swatch: SIGNAL_COLORS.red },
];

export const ANIM_IN = [
  { id: "fade",       label: "Fade in" },
  { id: "slide-up",   label: "Slide desde abajo" },
  { id: "slide-left", label: "Slide desde izquierda" },
  { id: "bounce",     label: "Bounce" },
];

export const TEXT_POSITIONS = [
  { id: "top",    label: "Superior" },
  { id: "center", label: "Centro" },
  { id: "bottom", label: "Inferior" },
];

export const IMAGE_DURATIONS = [5, 10, 15, 30, 60];

export const KEN_BURNS_OPTIONS = [
  { id: "none",     label: "Sin zoom" },
  { id: "zoom-in",  label: "Zoom in lento" },
  { id: "zoom-out", label: "Zoom out lento" },
];

export const FADE_OPTIONS = [
  { id: "none", label: "Sin fade", value: 0 },
  { id: "0.5",  label: "0.5s",     value: 0.5 },
  { id: "1",    label: "1s",       value: 1.0 },
  { id: "1.5",  label: "1.5s",     value: 1.5 },
];

export const GLITCH_OPTIONS = [
  { id: "none", label: "Ninguno", value: 0 },
  { id: "low",  label: "Baja",    value: 0.15 },
  { id: "mid",  label: "Media",   value: 0.35 },
  { id: "high", label: "Alta",    value: 0.6 },
];

export const OVERLAY_OPTIONS = [
  { id: "none",   label: "Ninguno", value: null },
  { id: "dark",   label: "Oscuro",  value: "rgba(5,5,5,0.3)" },
  { id: "orange", label: "Naranja", value: "rgba(255,138,0,0.15)" },
  { id: "red",    label: "Rojo",    value: "rgba(255,59,31,0.15)" },
];

export const CROP_OPTIONS = [
  { id: "cover", label: "Recortar centrado (cover)" },
  { id: "bars",  label: "Barras negras (contain)" },
];

// Default layer config used for new sessions + as backend save schema.
export function defaultLayers() {
  return {
    brand:     { enabled: true, cta: "Agenda una llamada", ctaColor: "gradient", handle: "@DAOS.ADS" },
    text:      {
      enabled: false,
      headline: "Gana más, pierde cero.",
      subtitle: "",
      position: "bottom",
      animation: "slide-up",
      startAt: 0,
      duration: 4,
      gradientWords: "",
      signalWords: "",
      signalColor: "amber",
    },
    subtitles: { enabled: false, mode: "manual", style: "shadow", items: [] }, // items: [{start,end,text}]
    effects:   {
      enabled: true,
      fadeIn: 0.5,
      fadeOut: 0.5,
      kenBurns: "none",
      parallax: false,
      glitch: "none",
      overlay: "none",
      glowPulse: true,
    },
    audio:     { enabled: false, volume: 0.8, fade: true, originalMode: "keep" }, // keep|mix|mute
    crop:      "cover",
  };
}
